"use client"

import { ErrorPage as ErroPageComponent } from "@/components/error/ErrorPage"

export default function NotFound() {
  return <ErroPageComponent />
}
